import Api from '../../../../shared/Api';
import IOrderContactAddress from './entities/IOrderContactAddress';

class OrderContactAddressApi {
    static getContactAddress(id: number): any {
        return new Api().get(`/views/orders/${id}/contactaddress`);
    }

    static updateOrderAddress(id: number, orderContactAddress: IOrderContactAddress): any {
        return new Api().put(`/views/orders/${id}/contactaddress/address`, orderContactAddress);
    }

    static updateOrderOwner(id: number, orderContactAddress: IOrderContactAddress): any {
        return new Api().put(`/views/orders/${id}/contactaddress/owner`, orderContactAddress);
    }
}

export default OrderContactAddressApi;
